import { useTheme } from '../../../../../contexts/ThemeContext';
import type { DiagramPalette } from '@diagram-kit/palettes';
import { diagramPaletteDark, diagramPaletteLight } from '@diagram-kit/palettes';

export type { DiagramPalette } from '@diagram-kit/palettes';

export function useDiagramTheme(): DiagramPalette {
  const { theme } = useTheme();
  return theme === 'dark' ? diagramPaletteDark : diagramPaletteLight;
}
